<script>
	export let description = "Please try reloading the page if this problem persists";
	export let title = "⚠️ You are not connected to the app";
</script>

<div class="modalContainer">
    <div class="modalTitle">{title}</div>
    <div class="modalDescription">{description}</div>
</div>

<style>
	.modalContainer {
        position: absolute;
        display: inline-flex;
        flex-direction: column;
        gap: 1rem;
        z-index: 100;
        padding: 2rem 1rem;
        background-color: #ffffff;
        border-radius: 10px;
        box-shadow: 7px 1px 17px -4px #424242;
        max-width: 30rem;
	}

    .modalTitle {
        font-family: Arial, Helvetica, sans-serif;
        font-style: normal;
		font-weight: bold;
		font-size: 22px;
		text-align: center;
		letter-spacing: 0.02em;
        color: black;
    }

	.modalDescription {
        font-family: Arial, Helvetica, sans-serif;
		font-style: normal;
		text-align: center;
		letter-spacing: 0.02rem;
        color: #555;
	}
</style>
